import React, { useState } from 'react';
import { adminLogin } from '../api';
import { AdminSession } from '../App';
import './LoginPage.scss';

interface Props {
  onLogin: (session: AdminSession) => void;
}

export default function LoginPage({ onLogin }: Props) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!name.trim() || !phone.trim()) {
      setError('Please enter your name and phone number.');
      return;
    }
    setLoading(true);
    try {
      const data = await adminLogin(name.trim(), phone.trim());
      // Backend wraps the record under data.admin
      const record = data.admin || data;
      onLogin({
        id: record.id || `admin_${Date.now()}`,
        name: record.name || name.trim(),
        phone: record.phone || phone.trim(),
      });
    } catch {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src="/logo.png" alt="Dubai Police Emblem" className="login-emblem" />
          <h1>Dubai Police</h1>
          <p className="login-subtitle">Admin Dashboard</p>
          <p className="login-subtitle-sub">999 Emergency Assistant</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              id="name"
              type="text"
              placeholder="Enter your full name"
              value={name}
              onChange={e => setName(e.target.value)}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              id="phone"
              type="tel"
              placeholder="e.g. +971501234567"
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p className="login-footer">Authorized Personnel Only</p>
      </div>
    </div>
  );
}
